import { mapState } from 'vuex'
export var scrollTo = {
  computed: {
    ...mapState({
      browser: state => state.report.browserUsed,
    }),
  },
  methods: {
    scrollToSection (section) {
      const target = section.replace('#', '')

      if (this.browser.name === 'ie') {
        window.scrollTo(0, this.sections[target])
      } else {
        window.scrollTo({
          top: this.sections[target],
          behavior: 'smooth',
        })
      }
    },
  },
}

export default scrollTo
